import React from "react";
import pluralize from "pluralize";
import { number, string } from "prop-types";

import Tooltip from "src/shared/seller-services/components/Tooltip";

import * as S from "./styled";

const SimilarHomes = ({ className, nearbyHomes, similarHomes }) => (
  <S.List className={className}>
    {Boolean(nearbyHomes) && (
      <S.ItemContainer>
        <S.ListItem>
          <S.Strong>{nearbyHomes}</S.Strong>
          {pluralize("home", nearbyHomes)} sold within 1<br /> mile of this one
        </S.ListItem>
      </S.ItemContainer>
    )}
    {Boolean(similarHomes) && (
      <S.ItemContainer>
        <S.ListItem>
          <S.Strong>{similarHomes}</S.Strong> {pluralize("home", similarHomes)}{" "}
          sold similar to
          <br /> this one
          <S.ListItemTooltip>
            <S.TooltipContainer>
              <Tooltip title="Similar homes">
                Similar homes are determined based on your property&apos;s
                location, price, and unit type
              </Tooltip>
            </S.TooltipContainer>
          </S.ListItemTooltip>
        </S.ListItem>
      </S.ItemContainer>
    )}
  </S.List>
);

SimilarHomes.propTypes = {
  className: string,
  nearbyHomes: number,
  similarHomes: number
};

SimilarHomes.defaultProps = {
  className: "",
  nearbyHomes: null,
  similarHomes: null
};

export default SimilarHomes;
